import { gql, useQuery } from '@apollo/client';
import { Avatar, AvatarProps } from '@chakra-ui/react';
import * as React from 'react';

import { CurrentUserAvatar_CurrentUserQuery } from './graphql-types/CurrentUserAvatar_CurrentUserQuery';

const CURRENT_USER_QUERY = gql`
  query CurrentUserAvatar_CurrentUserQuery {
    currentUser {
      _id
      displayName
      proxyProfilePictureUrl(
        input: { w: 256, h: 256, fit: "facearea", facepad: 10.0 }
      )
    }
  }
`;

export const CurrentUserAvatar: React.FC<AvatarProps> = (props) => {
  const { data } =
    useQuery<CurrentUserAvatar_CurrentUserQuery>(CURRENT_USER_QUERY);

  return (
    <Avatar
      name={data?.currentUser?.displayName}
      src={data?.currentUser?.proxyProfilePictureUrl ?? undefined}
      {...props}
    />
  );
};
